import { observer } from 'mobx-react-lite'
import { useEffect, useState } from 'react'
import { StyleSheet, View } from 'react-native'

import { BaseModalConfig } from '../'
import { DS } from '../../../../../design-system'
import { translate } from '../../../../../i18n'
import { useStore } from '../../../../../models'
import { events } from '../../../../../models/analytics/analytics-events'
import ChipsIcon from '../../../assets/Chips.svg'

export interface ThreeCardStartProps extends BaseModalConfig {}

export const ThreeCardStart = observer(({ onClose }: ThreeCardStartProps) => {
  const {
    analytics: { setEvent },
    game: { bots, isGameReadyToPlay, myPlayer, startGame }
  } = useStore()

  const [left, setLeft] = useState(0)
  const [ready, setReady] = useState(false)

  useEffect(() => {
    if (isGameReadyToPlay && myPlayer && bots.length === 2) {
      setReady(true)
    }
  }, [bots, myPlayer, isGameReadyToPlay])

  const handleLetsPlay = () => {
    startGame()
    setEvent(events.threeCard.started)
    onClose()
  }

  return (
    <View style={styles.container} onLayout={(event) => setLeft(event.nativeEvent.layout.width / 2 - 32)}>
      <View style={[styles.chipContainer, { left }]}>
        <ChipsIcon height={64} width={64} />
      </View>
      <View style={{ gap: 8 }}>
        <DS.Text style={styles.text} variant="Body Medium/Regular">
          Welcome to
        </DS.Text>
        <DS.Text variant="Heading 2/Medium" style={styles.text}>
          {translate('homeScreen.dailyPokerish')}
        </DS.Text>
        <DS.Text variant="Body Medium/Regular" style={styles.text}>
          Challenge Jenny and Taylor to 5 rounds and compete for the best stats!
        </DS.Text>
      </View>
      <DS.Button variant="Large/Primary" type="On Light" onPress={handleLetsPlay} disabled={!ready}>
        Let's Play
      </DS.Button>
    </View>
  )
})

const styles = StyleSheet.create({
  container: {
    paddingTop: 40,
    padding: 20,
    gap: 24
  },
  chipContainer: {
    position: 'absolute',
    top: '-20%'
  },
  text: {
    textAlign: 'center'
  }
})
